import React from "react";
import epayLogo from '../assets/images/epaycardlogo4.png'


export default function HeaderConfirmation() {

    return (
        <div className='container  container--welcome'>
        <div className='row--welcome'>
          <h3 className='text-center text--welcome'>Payment Confirmed</h3>
        </div>
      </div>
    )
}